import { MonitorIcon as Monitor } from "@phosphor-icons/react";
import TypeBadge from "@/components/fielddeps/TypeBadge";
import { SCREEN_KINDS, screenSummaryLine } from "@/lib/screenFields";

/** Iter 44 — display-file field references: counts, top display files, mapping honesty. */
export default function ScreenFieldsCard({ screen, topDisplayFiles = [], onFilter, testid = "fd-screen" }) {
  if (!screen) return null;
  if (!screen.references) {
    return (
      <div className="ml-card px-4 py-3 text-xs text-[var(--ml-text-secondary)]" data-testid={testid}>
        No display-file field references yet — parse DSPF (display file) DDS source and rebuild. Roles come only from the DDS usage code; database mapping only from REF / REFFLD.
      </div>
    );
  }
  return (
    <div className="ml-card px-4 py-3 space-y-3" data-testid={testid} data-total={screen.references}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)] flex items-center gap-1.5">
            <Monitor size={12} weight="bold" /> Display-file field references · {screen.references}
          </div>
          <div className="text-xs text-[var(--ml-text-secondary)] mt-1" data-testid={`${testid}-line`}>
            {screenSummaryLine(screen)} across <strong className="text-[var(--ml-text-primary)]">{screen.display_files}</strong> display file{screen.display_files === 1 ? "" : "s"} and {screen.fields} screen field{screen.fields === 1 ? "" : "s"} ·{" "}
            <strong className="text-[#0e6027]">{screen.mapped}</strong> mapped to a database field (REF / REFFLD) ·{" "}
            <strong style={{ color: "#8a6d00" }}>{screen.ambiguous_mappings}</strong> ambiguous database mapping{screen.ambiguous_mappings === 1 ? "" : "s"} (same-name only, not proven).
          </div>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {SCREEN_KINDS.map((k) => (
            <button key={k} type="button" onClick={() => onFilter?.({ reference_type: k, display_file: "*ANY" })} className="hover:opacity-80" data-testid={`${testid}-filter-${k}`} title={`Show ${k} screen fields`}>
              <TypeBadge type={k} count={screen[k] || 0} testid={`${testid}-${k}`} />
            </button>
          ))}
        </div>
      </div>
      {topDisplayFiles.length > 0 && (
        <ul className="text-xs divide-y divide-[var(--ml-border)]" data-testid={`${testid}-top`}>
          {topDisplayFiles.map((d) => (
            <li key={d.display_file} className="flex flex-wrap items-center justify-between gap-2 py-1.5" data-testid={`${testid}-file-${d.display_file}`}>
              <span className="ml-mono min-w-0">
                <button type="button" onClick={() => onFilter?.({ display_file: d.display_file })} className="font-semibold text-[var(--ml-primary)] hover:underline" data-testid={`${testid}-open-${d.display_file}`}>
                  {d.display_file}
                </button>
                <span className="text-[var(--ml-text-secondary)]"> · {d.record_format_count} format{d.record_format_count === 1 ? "" : "s"} · {d.field_count} field{d.field_count === 1 ? "" : "s"}{d.program_name ? ` · ${d.program_name}` : d.program_count > 1 ? ` · ${d.program_count} programs` : " · no program known"}</span>
              </span>
              <span className="ml-mono text-[10px] text-[var(--ml-text-secondary)] whitespace-nowrap">
                {d.screen.input} in · {d.screen.output} out · {d.screen.display} hidden · {d.mapped_count} mapped{d.ambiguous_count ? ` · ${d.ambiguous_count} ambiguous` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
